import React from 'react';
import type { TextAdConditions } from '../util/text-ads-util';
import AdsenseAd from './adsense/AdsenseAd';
import AdMarketplaceAds from './admarketplace/AdMarketplaceAds';

type Props = TextAdConditions & {
    slot?: string;
    isZeroResults: boolean;
    resultSize?: number;
    query?: string;
    isQA?: boolean;
    style?: React.CSSProperties;
    adsenceAdmarketplaceValue?: string;
};

const TextAds: React.FC<Props> = ({
    pageType,
    l1Category,
    device,
    currentPage,
    isZeroResults,
    resultSize,
    query,
    isQA,
    slot = 'afscontainer1',
    style,
    adsenceAdmarketplaceValue,
}) => {
    // console.log('adsenceAdmarketplaceValue------', adsenceAdmarketplaceValue)
    if (adsenceAdmarketplaceValue === 'A') {
        return (
            <AdsenseAd
                pageType={pageType}
                l1Category={l1Category}
                device={device}
                currentPage={currentPage}
                isZeroResults={isZeroResults}
                resultSize={resultSize}
                query={query}
                isQA={isQA}
                slot={slot}
                style={style}
            />
        );
    }
    if (adsenceAdmarketplaceValue === 'B') { 
        return (
            <AdMarketplaceAds
                pageType={pageType}
                l1Category={l1Category}
                device={device}
                currentPage={currentPage}
                isZeroResults={isZeroResults}
                query={query}
                isQA={isQA}
                resultsTa={1}
                resultsPa={12}
                style={style}
                slot={slot}
            />
        );
    }
    return null;
};

export default TextAds;
